import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const fetchProducts = async () => {
    const { data } = await apiClient.get("/products");
    return data;
};

export const fetchProduct = async (pid) => {
    const { data } = await apiClient.get(`/products/${pid}`);
    return data;
};

export const fetchKits = async () => {
    const { data } = await apiClient.get("/kits");
    return data;
};

export const submitLead = async (payload) => {
    const { data } = await apiClient.post("/leads", payload);
    return data;
};

export const createCheckoutSession = async (payload) => {
    const { data } = await apiClient.post("/checkout/session", payload);
    return data;
};

export const getCheckoutStatus = async (sessionId) => {
    const { data } = await apiClient.get(`/checkout/status/${sessionId}`);
    return data;
};
